module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-发布-内容来源.427fe.png";